(() => {
  function init(section) {
    if (!section) return;

    // Handle max tile width toggle (0 = full width)
    const styleText = section.getAttribute("style") || "";
    const maxWMatch = styleText.match(/--tile-max-w:\s*([0-9.]+)px/);
    const tileMaxW = maxWMatch ? Number(maxWMatch[1]) : 0;
    section.dataset.tileMaxDisabled = (!tileMaxW || tileMaxW <= 0) ? "true" : "false";

    const moneyFormat = section.dataset.moneyFormat || "${{amount}}";
    const excludeOOS = (section.dataset.excludeOos || "false") === "true";

    function guessCurrency() {
      if (window.Shopify?.currency?.active) return Shopify.currency.active;
      if (moneyFormat.includes("£")) return "GBP";
      if (moneyFormat.includes("$")) return "USD";
      if (moneyFormat.includes("€")) return "EUR";
      return "USD";
    }

    function formatMoney(cents) {
      try {
        if (window.Shopify && typeof Shopify.formatMoney === "function") {
          return Shopify.formatMoney(cents, moneyFormat);
        }
      } catch (e) {}
      const currency = guessCurrency();
      return (cents / 100).toLocaleString(undefined, { style: "currency", currency });
    }

    async function fetchMinPrice(handle) {
      const url = `${window.location.origin}/collections/${encodeURIComponent(handle)}/products.json?limit=250`;
      const res = await fetch(url, { headers: { Accept: "application/json" }, credentials: "same-origin" });
      if (!res.ok) throw new Error("products.json request failed");

      const text = await res.text();
      if (text.trim().startsWith("<")) throw new Error("products.json returned HTML");

      const data = JSON.parse(text);
      const products = data.products || [];

      let min = null;
      for (const p of products) {
        for (const v of (p.variants || [])) {
          if (excludeOOS && v.available === false) continue;
          const num = Number.parseFloat(v.price);
          if (!Number.isFinite(num)) continue;
          const cents = Math.round(num * 100);
          if (min === null || cents < min) min = cents;
        }
      }
      return min;
    }

    const tiles = Array.from(section.querySelectorAll(".c-tile[data-collection-handle]"));

    tiles.forEach(async (tile, i) => {
      const handle = tile.dataset.collectionHandle;
      const priceEl = tile.querySelector("[data-min-price]");
      const unitEl = tile.querySelector("[data-unit-out]");
      if (!handle || !priceEl) return;

      if (unitEl && tile.dataset.unit) unitEl.textContent = tile.dataset.unit;

      priceEl.textContent = "…";
      await new Promise((r) => setTimeout(r, i * 120));

      try {
        const min = await fetchMinPrice(handle);
        priceEl.textContent = (min === null) ? "—" : formatMoney(min);
      } catch (e) {
        priceEl.textContent = "—";
        // Uncomment to debug on live:
        // console.warn("Tile price failed:", handle, e);
      }
    });
  }

  function initAll() {
    document.querySelectorAll(".c-tiles").forEach(init);
  }

  // Normal storefront load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Theme editor events
  document.addEventListener("shopify:section:load", (e) => {
    const wrapper = document.getElementById(`shopify-section-${e.detail.sectionId}`);
    init(wrapper?.querySelector(".c-tiles"));
  });

  document.addEventListener("shopify:section:select", (e) => {
    const wrapper = document.getElementById(`shopify-section-${e.detail.sectionId}`);
    init(wrapper?.querySelector(".c-tiles"));
  });
})();